import React, { useMemo } from "react";

import { useStateManagerContext } from "~/context/stateManager";
import { useDemographics } from "~/sdks/LocalDemographics/context";
import { useTranslation } from "react-i18next";

import { Text } from "@local-logic/core/ui";
import { Attribution } from "~/components/Attribution";

import type { LocalDemographicsProps } from "~/sdks/LocalDemographics/types";

import * as styles from "./styles";

export const Footer = () => {
  const { t } = useTranslation(["localDemographics", "common"]);
  const { demographicsState } = useDemographics();
  const { sdkState } = useStateManagerContext<LocalDemographicsProps>();
  const locale = sdkState.globalOptions?.locale;
  const { country } = demographicsState;

  const value = useMemo(() => {
    if (country === "CAN") {
      if (locale === "fr") {
        return "0,5";
      }

      return "0.5";
    }

    return "0.3";
  }, [locale, country]);

  const unit = useMemo(
    () => t(`common:distance.${country === "CAN" ? "kilometer" : "mile"}`),
    [locale, country],
  );

  return (
    <div className={styles.container}>
      <Text
        noMargin
        variant="caption1"
        color="--ll-color-on-background-variant1"
      >
        {t("note", { value, unit })}
      </Text>
      <Attribution />
    </div>
  );
};
